import { render } from "./AlignmentWizard.vue?vue&type=template&id=9bc51d6e&scoped=true&ts=true"
import script from "./AlignmentWizard.vue?vue&type=script&lang=ts"
export * from "./AlignmentWizard.vue?vue&type=script&lang=ts"

import "./AlignmentWizard.vue?vue&type=style&index=0&id=9bc51d6e&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc51d6e"]])

export default __exports__